import './predective.css'

export default () => {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.query = ''
      this.pageResults = []
      this.articleResults = []
      this.results = []
      this.loading = true
      this.initEventListeners()
    }

    connectedCallback() {
      const searchBar = document.querySelector('.search-form__input')
      document.querySelector('.search-form__input').addEventListener('input', () => {
        const query = searchBar.value.trim()
        this.search(query)
      })
    }

    debounce(fn, wait) {
      let t
      return (...args) => {
        clearTimeout(t)
        t = setTimeout(() => fn.apply(this, args), wait)
      }
    }

    highlightQuery(text, query) {
      const regex = new RegExp(`(${query})`, 'gi');
      return text.replace(regex, "<span class='highlight'>$1</span>");
    }

    fetchProducts(query) {
      const debouncedFetch = this.debounce(() => {
        fetch(
          `${window.Shopify.routes.root}search/suggest.json?q=${query}&resources[limit]=10`
        )
          .then((response) => response.json())
          .then((suggestions) => {
            this.querySelector('.search-results').classList.remove('hidden')
            // eslint-disable-next-line
            const results = suggestions.resources.results;
            // eslint-disable-next-line
            const allEmpty = !results.pages?.length && !results.articles?.length && !results.collections?.length && !results.products?.length;

            if (!allEmpty) {
              this.querySelector('.search-popular').classList.add('hidden')
              this.querySelector('.search-no-result').classList.add('hidden');
              this.querySelector('.search-results').classList.remove('hidden');

              this.querySelector('.suggested-results-pages').innerHTML = '';
              if (results.pages && results.pages.length > 0) {
                this.querySelector('.search-pages .header-search__category').classList.remove('hidden');
                this.pageResults = results.pages;
                let html = '';
                this.pageResults.forEach((result) => {
                  html += `<li class='flow-root'>
              <a href='${result.url}'><span class='text-[#0F121799]'>${this.highlightQuery(result.title, query)}</a>
            </li>`;
                });
                this.querySelector('.suggested-results-pages').insertAdjacentHTML(
                  'beforeend',
                  html
                );
              }

              if (results.articles && results.articles.length > 0) {
                this.querySelector('.search-articles .header-search__category').classList.remove('hidden');
                this.querySelector('.suggested-results-article').innerHTML = '';
                this.articleResults = results.articles;
                let html = '';
                this.articleResults.forEach((result) => {
                  html += `<li class='flow-root'>
              <a href='${result.url}'><span class='text-[#0F121799]'>${this.highlightQuery(result.title, query)}</a>
            </li>`;
                });
                this.querySelector('.suggested-results-article').insertAdjacentHTML(
                  'beforeend',
                  html
                );
              }

              if (results.collections && results.collections.length > 0) {
                this.querySelector('.search-collections .header-search__category').classList.remove('hidden');
                this.querySelector('.suggested-results-collections').innerHTML = '';
                this.articleResults = results.collections;
                let html = '';
                this.articleResults.forEach((result) => {
                  html += `<li class='flow-root'>
              <a href='${result.url}'><span class='text-[#0F121799]'>${this.highlightQuery(result.title, query)}</a>
            </li>`;
                });
                this.querySelector('.suggested-results-collections').insertAdjacentHTML(
                  'beforeend',
                  html
                );
              }

              if (results.products && results.products.length > 0) {
                this.results = results.products;
                let html = '';
                this.results.forEach((result) => {
                  html += `
              <div class='bg-white border border-[#E0E0E0] pb-4 search-result-product'>
                <a href='/products/${result.handle}' class='group relative h-80'>
                  <div class='h-40 1000:h-56 w-full overflow-hidden rounded-md bg-gray-200 group-hover:opacity-75'>
                    <img
                      src='${result.image}'
                      class='h-full w-full object-cover object-center opacity-100'
                      alt="${result.title}">
                  </div>
                  <div class="px-4">
            <h3 class='mt-2 md:mt-4 text-16 font-normal mb-0.5 text-[#0F121799] text-center leading-20px font-regular'>
                     ${this.highlightQuery(result.title, query)}
             </h3>
                  <p class='text-sm text-gray-dark font-normal text-center mt-3 text-14'>${ this.formatMoney(
                    {
                      amount: result.price,
                      currencyCode: Shopify.currency.active,
                    }, true
                  )}</p>
                  </div>
                </a>
              </div>
              `;
                });
                this.querySelector('.search-results-grid').innerHTML = html;
                this.querySelector('.view-more-products').setAttribute('href', `/search?q=${query}&type=product`);
                this.querySelector('.view-more-products').classList.remove('hidden');
              } else {
                this.querySelector('.view-more-products').classList.add('hidden');
              }
              this.loading = false;
            } else {
              this.querySelector('.search-popular').classList.add('hidden')
              this.loading = false;
              this.results = 0;
              this.querySelector('#search-terms').innerHTML = query
              this.querySelector('.search-no-result').classList.remove('hidden');
              this.querySelector('.search-results').classList.add('hidden');
            }
          });
      }, 1000);

      debouncedFetch();
    }


    search(query) {
      this.fetchProducts(query)
    }

    formatMoney({amount, currencyCode = 'USD'}, cents = false) {
      let amt = amount;
      if (Number.isNaN(amt))
        // eslint-disable-next-line no-console
        return console.error('utils/format-money.js: No amount value passed.');

      if (cents) amt /= 100;

      const isWholeNumber = amt % 1 === 0;

      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: isWholeNumber ? 0 : 2,
        maximumFractionDigits: 2,
      });

      return formatter.format(amt);
    };

    initEventListeners() {

    }
  }

  const init = () => {
    if (!customElements.get("predictive-search")) {
      customElements.define('predictive-search', PredictiveSearch);
    }
  };

  init();
};
